export default "__VITE_ASSET__oXbRIk7I__"